///
/// EarthBrowser
///
/// Created by Matt Giger on 9/13/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Fetches the server-issued anonymous device id (eb_anon_id cookie). The
/// cookie itself is httpOnly; the id arrives in the response body and is
/// mirrored into the engagement slice and registered as a PostHog super
/// property so funnel events stay stitched to the device even if PostHog's
/// own distinct id resets (Safari ITP clears script-writable storage after
/// seven days without a visit; the server-set cookie survives).
///

import { launchEntry, launchPlatform, setAnalyticsSubject } from "@/utils/analytics"
import posthog from "posthog-js"
import { authenticatedApi } from "./API/authenticatedApi"
import { setAnonymousId } from "./engagementSlice"

export const engagementApi = authenticatedApi.injectEndpoints({
	endpoints: (builder) => ({
		getAnonymousSession: builder.query<{ anonymousId: string }, void>({
			// entry/platform let the server's daily-touch row (all-visitor
			// DAU/return metrics) carry how this launch arrived
			query: () => `/api/session/anonymous?entry=${launchEntry()}&platform=${launchPlatform()}`,
			async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled
					dispatch(setAnonymousId(data.anonymousId))
					setAnalyticsSubject(data.anonymousId)
					try {
						posthog.register({ eb_anon_id: data.anonymousId })
					} catch { /* analytics is best-effort */ }
				} catch {
					// Offline or server error: session counting still works
					// from the persisted slice alone
				}
			},
		}),
	}),
})

export const { useGetAnonymousSessionQuery } = engagementApi
